import { useTranslation } from 'react-i18next'

import {
    CONTACT_VERIFICATION_EMAIL_KEY,
    CONTACT_VERIFICATION_IDENTITY_DATA_KEY,
    CONTACT_VERIFICATION_PHONE_KEY,
    CONTACT_VERIFICATION_VAT_KEY,
    getItemFromLS,
} from '../../core/api'
import VerificationIdentityFormCard from './VerificationIdentityFormCard'

export default function VerificationIdentityCreateCard() {
    const { t } = useTranslation()
    const identityData = getItemFromLS(CONTACT_VERIFICATION_IDENTITY_DATA_KEY) || {}

    return (
        <VerificationIdentityFormCard
            title={t('verification.createIdentityDataTitle')}
            initialValues={{
                vat: identityData.vat || getItemFromLS(CONTACT_VERIFICATION_VAT_KEY) || '',
                name: identityData.name || '',
                org: identityData.org || '',
                commercialRegistrationQueryCode: identityData.commercialRegistrationQueryCode || '',
                street: identityData.street || '',
                city: identityData.city || '',
                zipcode: identityData.zipcode || '',
                country: identityData.country || '',
            }}
            email={getItemFromLS(CONTACT_VERIFICATION_EMAIL_KEY) || ''}
            phone={getItemFromLS(CONTACT_VERIFICATION_PHONE_KEY) || ''}
            noPreviousData={true}
        />
    )
}
